export default __webpack_public_path__ + "static/media/018-boat.ba04205c.png";